import { envMode } from "@ch/api";
import { usePostHog } from "posthog-js/react";
import { useEffect, useRef } from "react";
import useUserDetails from "../useUserDetails/useUserDetails";
import useUserSubscription from "../useUserSubscription/useUserSubscription";

const usePostHogIdentify = () => {
  const postHog = usePostHog();

  const { userId, email, phone, fullName, gender, age } = useUserDetails();

  const {
    activeSubscriptionsList,
    expiredSubscriptionsList,
    activeSubscriptionsCount,
    expiredSubscriptionsCount,
  } = useUserSubscription();

  const userIdentifiedRef = useRef(false);

  useEffect(() => {
    if (userId && !userIdentifiedRef.current) {
      postHog.identify(userId, {
        user_id: userId,
        email,
        phone,
        name: fullName,
        gender,
        age,
        environment: envMode,
        platform: "web",
        active_subscriptions: activeSubscriptionsList,
        expired_subscriptions: expiredSubscriptionsList,
        active_subscriptions_count: activeSubscriptionsCount,
        expired_subscriptions_count: expiredSubscriptionsCount,
      });

      userIdentifiedRef.current = true;
    }

    return () => {
      userIdentifiedRef.current = false;
    };
  }, [
    activeSubscriptionsCount,
    activeSubscriptionsList,
    expiredSubscriptionsCount,
    expiredSubscriptionsList,
    email,
    fullName,
    gender,
    phone,
    postHog,
    userId,
    age,
  ]);
};

export default usePostHogIdentify;
